import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { FeatureService } from '../services';
import { IBrandFeatures } from '../models';
import { FeatureActions } from './feature.actions';

@State<IBrandFeatures>({
  name: 'features',
  defaults: {},
})
@Injectable()
export class FeatureState {
  constructor(private featureService: FeatureService) {}

  @Selector()
  public static getState(state: IBrandFeatures): IBrandFeatures {
    return state;
  }

  @Selector()
  public static isFeatureEnabled(state: IBrandFeatures) {
    return (featId: string) => {
      const feat = state[featId];
      return !feat || feat.enabled;
    };
  }

  /**
   * For this initial implementation we are hardcoding the features.
   * In the future, we can load the features data from an API
   *
   * @param {StateContext<IBrandFeatures>} ctx
   * @param {SetBrandFeatures} { payload }
   * @memberof FeatureState
   */
  @Action(FeatureActions.Init)
  public loadFeatures(
    ctx: StateContext<IBrandFeatures>,
    { brand, stage }: FeatureActions.Init
  ): Observable<IBrandFeatures> {
    return this.featureService
      .getFeatures(brand, stage)
      .pipe(tap((features) => ctx.setState(features)));
  }

  @Action(FeatureActions.Add)
  public addBrandFeature(
    ctx: StateContext<IBrandFeatures>,
    { features }: FeatureActions.Add
  ): void {
    const stateModel = ctx.getState();
    ctx.patchState({ ...stateModel, ...features });
  }
}
